const getRandomNumber = (max: number): number => {
  return Math.floor(Math.random() * max);
};

export { getRandomNumber };
